import React, { useCallback } from 'react';
import { findAgentInfoAPI } from '../../services/agentInfoService';

type Hook = {
  findAgentInfo: (userId: string) => Promise<any>;
};

const UseAgentInfo = (): Hook => {
  const findAgentInfo = useCallback(async (userId: string) => {
    try {
      return await findAgentInfoAPI(userId);
    } catch (error) {
      console.error('Failed to fetch  agent Info:', error);
      throw error;
    }
  }, []);

  return { findAgentInfo };
};

export default UseAgentInfo;
